import { CalendarToday } from "@mui/icons-material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useField, useFormikContext } from "formik";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

// Estilo constante para el ícono
const StyledIcon = {
  color: "white",
};

const FormikDateTimePicker = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const fieldMetadata = useArtFieldMetadata(props.name);
  const label = buildArtFieldLabel(props.label, fieldMetadata);

  // Si no hay valor, usa null para evitar errores de formato
  const value = field.value ? new Date(field.value) : null;

  const handleChange = (newValue) => {
    setFieldValue(props.name, newValue);
  };

  return (
    <DateTimePicker
      ampm={false}
      format="dd/MM/yyyy HH:mm"
      value={value}
      onChange={handleChange}
      components={{
        OpenPickerIcon: CalendarToday,
      }}
      componentsProps={{
        openPickerButton: {
          sx: StyledIcon,
        },
      }}
      slotProps={{
        textField: {
          variant: props.variant || "outlined",
          fullWidth: true,
          error: meta.touched && !!meta.error,
          helperText: meta.touched && meta.error ? meta.error : null,
        },
      }}
      cancelLabel={props.disabledButtons ? "" : undefined}
      okLabel={props.disabledButtons ? "" : undefined}
      {...props}
      label={label}
    />
  );
};

export default FormikDateTimePicker;
